import {ButtonPrimary} from "./";
import styled from "styled-components";

export const ButtonSecondary = styled(ButtonPrimary)`
	border: 4px solid #db2218;
	color: #db2218;
	background-color: #ffffff;
`;
